export default __webpack_public_path__ + "static/media/756.bc06ebb4.png";